import React from 'react';

import { Flex } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';
import StatusCaption from '../StatusCaption';

export function EquipmentStatusCaption() {
  const options = [
    {
      type: 'moving',
      title: getResourceTo('maps.legend.truckOnAndMoving'),
      captionItemLabelClassname: 'green-label'
    },
    {
      type: 'stopped',
      title: getResourceTo('maps.legend.truckOnAndStopped'),
      captionItemLabelClassname: 'purple-label'
    },
    {
      type: 'turnedOff',
      title: getResourceTo('maps.legend.truckOff'),
      captionItemLabelClassname: 'black-label'
    }
  ];

  const toggleLabel = getResourceTo(
    'permission.tracker.equipment_route_status'
  );

  return (
    <Flex
      className="caption-info caption-equipment"
      alignItems="center"
      gap={16}
    >
      <StatusCaption
        toggleLabel={toggleLabel}
        options={options.map((option) => ({
          ...option,
          unchecked: false
        }))}
      />
    </Flex>
  );
}
